"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const GridIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("rect", {
    width: "31",
    height: "31",
    x: "0.5",
    y: "0.5",
    rx: "3.5"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    width: "23",
    height: "23",
    x: "4.5",
    y: "4.5",
    rx: "11.5"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    width: "15",
    height: "15",
    x: "8.5",
    y: "8.5",
    rx: "3.5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2 2l28.284 28.284m0-28.284L2 30.284"
  })))
});
GridIcon.displayName = 'GridIcon';
var _default = exports.default = GridIcon;